import CheckoutComponent from "./CheckoutComponent";
import CheckoutPickup from "./CheckoutPickup";
import CheckoutPaySystem from "./CheckoutPaySystem";

export default class CheckoutDelivery {
    private BX: any;
    private ymaps: any;
    private CheckoutPickup: any;
    private boxberry: any;
    private delivery5postMap: any;

    constructor(BX: any, ymaps: any, boxberry: any) {
        this.BX = BX;
        this.ymaps = ymaps;
        this.boxberry = boxberry;
        if (typeof (CheckoutComponent.arResult.DELIVERY) == 'undefined') {
            CheckoutComponent.arResult.DELIVERY = {};
        }

        this.delivery5postMap = new fivepost.PickupPointsMap({
            apikey: '53b575d1-0ce1-45fc-a97d-f7fa12560485',
            target: '#map_5post',
            onLoadYandexApi: () => {
                // При загрузке Yandex Api
            },
            onInit: () => {
                // При инициализации компонента
            },
            onCancel: (point: any) => {
                // При отмене выбора пункта ПВЗ
            }
        });
    }
    init(){
        this.bindEvents();
        CheckoutDelivery.calculateAllDeliveryServices();
    }
    bindEvents() {
        let self = this;
        $(document).on('click', '.cart-delivery-wrapper .delivery-item', function(e){
            self.setDeliveryService(e);
        });
        $(document).on('click', '.delivery-item', function(e){
            self.setDeliveryService(e);
        });
        $(document).on('click', '.calendar-btn, input.delivery-date', function(e){
            self.showCalendar(e);
        });
        $(document).on('change', 'input.delivery-date', function(e){
            self.setDeliveryDate(e);
        });
        $(document).on('change', 'select.delivery-time', function(e){
            self.setDeliveryTime(e);
        });
        $(document).on('click', '.bxb-wrapper, .bxblink-wrapper', function(e){
            self.tryOpenBoxberryModal(e);
        });
        $(document).on('click', '.5post-wrapper', function(e){
            self.open5postModal(e);
        });
        $(document).on('click', '.paysystem-item', function(){
            self.setPaySystem($(this).data('code'), $(this).closest('.basket-group'));
        });
        $(document).on('change', '.dadata-input', function(e){
            self.setDaData(e);
        });
        $(document).on('click', '.open-profiles-list-btn', function(e){
            self.openDeliveryProfilesDialog(e);
        });
        $(document).on('click', '.delivery-profile-item', function(e){
            self.selectDeliveryProfile(e);
        });
        $(document).on('click', '.add-delivery-profile-btn', function(){
            self.openNewDeliveryProfilesDialog();
        });
        $(document).on('click', '.save-delivery-profile-btn', function(e){
            self.saveDeliveryProfile(e);
        });
        $(document).on('click', '.delete-profile-btn', function(e){
            self.deleteDeliveryProfile(e);
        });
        $(document).on('click', '.edit-profile-btn', function(e){
            self.editDeliveryProfile(e);
        });
        $(document).on('click', '.boxberry_container_close', function(e){
            $('.bxblink')
                .text('Выбрать пункт выдачи на карте...')
                .closest('.delivery-item')
                .removeClass('disabled');
        });
        $('#new-delivery-profiles-dialog').on('hide.bs.modal', function () {
            $('#delivery-profiles-dialog').modal();
        });
    }

    static initSelectedDelivery() {
        let $service, $basketGroup, $cityInput, $streetInput, $houseInput, $dateInput;
        let self = this;
        for(var k in CheckoutComponent.arResult.BASKET.GROUPS) {
            $basketGroup = $('.basket-group[data-group="'+k+'"]');
            $service = $basketGroup.find('.delivery-item.checked');
            if($service.length) {
                
                if($service.data('code') == 'pickup_today' || $service.data('code') == 'pickup_tomorrow') {
                    $service.removeClass('checked').trigger('click');
                }
                if($service.data('code') == 'mkad:default' || $service.data('code') == 'bxb_courier_delivery' ||
                    $service.data('code') == 'POST') {
                    $cityInput = $basketGroup.find('.delivery-city-input');
                    $streetInput = $basketGroup.find('.delivery-street-input');
                    $houseInput = $basketGroup.find('.delivery-house-input');
                    $dateInput = $basketGroup.find('.delivery-date');

                    self.initCityInput($cityInput);

                    let deliveryDate = CheckoutComponent.arResult.BASKET.GROUPS[k].DELIVERY_DATE;
                    $dateInput.val(deliveryDate);

                    if (CheckoutComponent.arResult.BASKET.GROUPS[k].DADATA !== null) {
                        if (CheckoutComponent.arResult.BASKET.GROUPS[k].DADATA.hasOwnProperty('city') && CheckoutComponent.arResult.BASKET.GROUPS[k].DADATA.city.fias) {
                            self.initStreetInput($streetInput, k, CheckoutComponent.arResult.BASKET.GROUPS[k].DADATA.city.fias);
                        }
                        if (CheckoutComponent.arResult.BASKET.GROUPS[k].DADATA.hasOwnProperty('street') && CheckoutComponent.arResult.BASKET.GROUPS[k].DADATA.street.fias) {
                            self.initHouseInput($houseInput, k, CheckoutComponent.arResult.BASKET.GROUPS[k].DADATA.street.fias);
                        }
                    }
                }
            }
        }
    }

    static calculateAllDeliveryServices() {
        let basketGroups = [];
        let services = [];
        for(var k in CheckoutComponent.arResult.BASKET.GROUPS) {
            basketGroups.push(k);
            for(var i in CheckoutComponent.arResult.BASKET.GROUPS[k].SERVICES) {
                services.push(CheckoutComponent.arResult.BASKET.GROUPS[k].SERVICES[i].ID);
            }
        }
        CheckoutDelivery.calculateDelivery([k], services, true);
    }

    static calculateDelivery(basketGroupIds: any, serviceIds: any, reloadTotal:boolean)
    {
        let $component: any;
        let $deliveryService: any;
        for(var k in basketGroupIds) {
            $component = $('#delivery-'+basketGroupIds[k]+'-component');
            for(var i in serviceIds) {
                $component
                    .find('.delivery-item[data-id="'+serviceIds[i]+'"]')
                    .find('.delivery-item-price').html('<span class="delivery-price-loader"></span>');
            }
        }
        $.post(
            document.location.href,
            {
                checkoutDeliveryAjaxAction: 'calculateDeliveryPrice',
                sessid: window.BX.bitrix_sessid(),
                arResult: CheckoutComponent.arResult,
                basketGroupId: basketGroupIds,
                serviceIds: serviceIds
            },
            function(data) {
                let bReload = false;
                for(var basketGroupId in data) {
                    $component = $('#delivery-' + basketGroupId + '-component');
                    for(var serviceId in data[basketGroupId]) {
                        $deliveryService = $component.find('.delivery-item[data-id="'+serviceId+'"]');
                        if (data[basketGroupId][serviceId].status == 1) {
                            bReload = true;
                            let currentCode = '';
                            for(var serviceCode in CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SERVICES) {
                                if(CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SERVICES[serviceCode].ID == serviceId) {
                                    currentCode = serviceCode;
                                    CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SERVICES[serviceCode].DELIVERY_PRICE = data[basketGroupId][serviceId].price;
                                }
                            }
                            if(CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SELECTED_DELIVERY == serviceId) {
                                CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DELIVERY_PRICE = data[basketGroupId][serviceId].price;
                            }
                            let price = data[basketGroupId][serviceId].price > 0 ?
                                data[basketGroupId][serviceId].price_formatted :
                                (currentCode == 'mkad:default' ? '<span class="text-muted">Бесплатно</span>' : '<span class="text-success">Бесплатно</span>');
                            $deliveryService.find('.delivery-item-price').html(price);
                            if (currentCode == '5_post' && data[basketGroupId][serviceId].price == 0) {
                                $deliveryService.find('.delivery-item-price').html('');
                            }
                            if (currentCode == 'bxb_courier_delivery') {
                               if (data[basketGroupId][serviceId].default_price != null && data[basketGroupId][serviceId].price == 0) {
                                    $deliveryService.find('.delivery-item-price').html(data[basketGroupId][serviceId].default_price);
                                } else if (data[basketGroupId][serviceId].price == 0) {
                                    $deliveryService.find('.delivery-item-price').html('<span class="text-success">Бесплатно</span>');
                                }
                            }
                        } else {
                            $deliveryService
                                .find('.delivery-house-input, .delivery-street-input, .delivery-city-input')
                                .parent('div')
                                .addClass('error-input')
                                .removeClass('success-input')
                            $deliveryService.find('.delivery-item-price').html('<span class="component-error-message">' + data[basketGroupId][serviceId].message + '</span>');
                        }
                        $deliveryService.find('.delivery-item-description.delivery-time').html(data[basketGroupId][serviceId].deliveryDescription);

                        if(data[basketGroupId][serviceId].deliveryDate) {
                           $deliveryService.find('input.delivery-date')
                               .data('min-date', data[basketGroupId][serviceId].deliveryDate)
                               .attr('data-min-date', data[basketGroupId][serviceId].deliveryDate)
                        } else {
                            $deliveryService.find('input.delivery-date')
                                .data('min-date', '')
                                .attr('data-min-date', '')
                        }
                        if(data[basketGroupId][serviceId].avail == 'N') {
                            let serviceCode = $deliveryService.data('code');
                            if(serviceCode != 'bxb_courier_delivery') {
                                $deliveryService.removeClass('checked').find('.delivery-item-params').hide();
                                $deliveryService.hide();
                            } else {
                                $deliveryService.find('input[type="text"]').val('');
                                $deliveryService.find('.success-input').removeClass('success-input');
                            }

                            if(CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SELECTED_DELIVERY == serviceId) {
                                CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SELECTED_DELIVERY = null;
                                let $dialog = $('#delivery-error-dialog');
                                $dialog.find('.modal-body').html(data[basketGroupId][serviceId].avail_message);
                                $dialog.appendTo('body').modal();
                            }
                        } else {
                            $deliveryService.show();
                        }
                    }
                }
                if(bReload && reloadTotal) {
                    CheckoutComponent.reloadComponents(['total']);
                }
            },
            'json'
        );
    }

    editDeliveryProfile(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let profileId = $(e.target).closest('.delivery-profile-item').data('id');
        let $dialog = $('#new-delivery-profiles-dialog');
        $('#delivery-profiles-dialog').modal('hide');
        this.clearDeliveryProfileForm();
        $dialog.find('.save-delivery-profile-btn')
            .text('Сохранить изменения')
            .data('id', profileId)
            .attr('data-id', profileId);
        $dialog.find('.modal-title').text('Редактирование адреса');
        if($(window).width() < 768) {
            $dialog.find('.modal-content').css('min-height', $(window).height()+'px');
        } else {
            $dialog.find('.modal-content').css('min-height', 'auto');
        }
        $dialog.appendTo('body').modal();
    }

    openNewDeliveryProfilesDialog() {
        $('#delivery-profiles-dialog').modal('hide');
        let $dialog = $('#new-delivery-profiles-dialog');
        $dialog.find('.save-delivery-profile-btn')
            .text('Сохранить новый адрес')
            .data('id', '')
            .attr('data-id', '');
        this.clearDeliveryProfileForm();
        $dialog.find('.modal-title').text('Добавление адреса');
        if($(window).width() < 768) {
            $dialog.find('.modal-content').css('min-height', $(window).height()+'px');
        } else {
            $dialog.find('.modal-content').css('min-height', 'auto');
        }
        $dialog.appendTo('body').modal();
    }

    openDeliveryProfilesDialog(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let basketGroup = $(e.target).closest('.basket-group').data('group');
        let $dialog = $('#delivery-profiles-dialog');
        if($(window).width() < 768) {
            $dialog.find('.modal-content').css('min-height', $(window).height()+'px');
        } else {
            $dialog.find('.modal-content').css('min-height', 'auto');
        }
        $dialog
            .data('basket-group', basketGroup)
            .attr('data-basket-group', basketGroup)
            .appendTo('body')
            .modal();
    }

    deleteDeliveryProfile(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let profileId = $(e.target).closest('.delivery-profile-item').data('id');
        $.post(
            '/',
            {
                ajaxAction: 'deleteDeliveryProfile',
                id: profileId,
            },
            function(data) {
                if(data.status == 1) {
                    let $currentProfile = $('.delivery-profile-item[data-id="'+profileId+'"]');
                    if($currentProfile.hasClass('checked')) {
                        let $newProfile = $('.delivery-profile-item:not(".checked")').eq(0);
                        let $dialog = $('#delivery-profiles-dialog');
                        if($newProfile.length) {
                            $newProfile.addClass('checked');
                            for(var k in CheckoutComponent.arResult.DELIVERY.PROFILES) {
                                if(k == $newProfile.data('id')) {
                                    CheckoutComponent.arResult.DELIVERY.PROFILES[k].SELECTED = 'Y';
                                    let profile = CheckoutComponent.arResult.DELIVERY.PROFILES[k];
                                    let address = profile.STREET + ', ' + profile.HOUSE;
                                    if(profile.FLAT) {
                                        address += ', ' + profile.FLAT;
                                    }
                                    let $basketGroup = $('.basket-group[data-group="'+$dialog.data('basket-group')+'"]');
                                    $basketGroup.find('.selected-profile').html(profile.CITY + '<br>' + address);
                                    break;
                                }
                            }
                        } else {
                            let $basketGroup = $('.basket-group[data-group="'+$dialog.data('basket-group')+'"]');
                            $dialog.modal('hide');
                            $basketGroup.find('.delivery-form').removeClass('hidden');
                            $basketGroup.find('.current-profile').hide();
                        }
                    }
                    $currentProfile.remove();
                    delete CheckoutComponent.arResult.DELIVERY.PROFILES[profileId];
                }
            },
            'json'
        );
    }

    clearDeliveryProfileForm() {
        let $dialog = $('#new-delivery-profiles-dialog');
        $dialog.find('.delivery-city-input')
            .val('')
            .prop('disabled', false)
            .parent('div')
            .removeClass('error-input')
            .removeClass('success-input');
        $dialog.find('.delivery-street-input')
            .val('')
            .prop('disabled', true)
            .parent('div')
            .removeClass('error-input')
            .removeClass('success-input');
        $dialog.find('.delivery-house-input')
            .val('')
            .prop('disabled', true)
            .parent('div')
            .removeClass('error-input')
            .removeClass('success-input');
        $dialog.find('input[name="house"]').val('');
        $dialog.find('input[name="flat"]').val('');
        $dialog.find('input[name="house"]').val('');
        $dialog.find('.save-delivery-profile-btn').prop('disabled', true);
        $dialog.find('.error-message').empty();
    }

    saveDeliveryProfile(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let $btn = $(e.target)
        let $modal = $btn.closest('.modal');
        let $errorMessage = $modal.find('.error-message');
        let profile = {
            CITY: $modal.find('.delivery-city-input').val(),
            STREET: $modal.find('.delivery-street-input').val(),
            HOUSE: $modal.find('input[name="house"]').val(),
            FLAT: $modal.find('input[name="flat"]').val(),
            FIAS: $modal.find('input[name="fias"]').val(),
        };
        let action, bUpdate;
        if($btn.data('id')) {
            action = 'updateDeliveryProfile';
            profile.id = $btn.data('id');
            bUpdate = true;
        } else {
            action = 'addDeliveryProfile';
            bUpdate = false;
        }
        $errorMessage.empty();
        $btn.prop('disabled', true);
        $.post(
            '/?ajaxAction='+action,
            profile,
            function(data) {
                if(data.status == 1) {
                    CheckoutComponent.arResult.DELIVERY.PROFILES[data.id] = profile;
                    let $profilesModal = $('#delivery-profiles-dialog');
                    if(bUpdate) {
                        let $currrentProfile = $profilesModal.find('.delivery-profile-item[data-id="'+profile.id+'"]');
                        let address = profile.STREET + ', ' + profile.HOUSE;
                        if(profile.FLAT) {
                            address += ', ' + profile.FLAT;
                        }
                        $currrentProfile.find('.address').html(
                            profile.CITY + '<br>' + address
                        )
                        for(var k in CheckoutComponent.arResult.DELIVERY.PROFILES) {
                            if(k == profile.id) {
                                CheckoutComponent.arResult.DELIVERY.PROFILES[k] = {
                                    CITY: profile.CITY,
                                    STREET: profile.STREET,
                                    HOUSE: profile.HOUSE,
                                    FLAT: profile.FLAT,
                                    FIAS: profile.FIAS,
                                };
                            }
                        }
                    } else {
                        $profilesModal.find('.delivery-profile-item').removeClass('checked');
                        let $newProfile = $profilesModal.find('.delivery-profile-item').eq(0).clone();
                        let address = profile.STREET + ', ' + profile.HOUSE;
                        if(profile.FLAT) {
                            address += ', ' + profile.FLAT;
                        }
                        $newProfile.find('.address').html(
                            profile.CITY + '<br>' + address
                        ).closest('.delivery-profile-item')
                            .data('id', data.id).attr('data-id', data.id)
                            .addClass('checked')
                            .appendTo($profilesModal.find('.modal-body'));
                        let $dialog = $('#delivery-profiles-dialog');
                        let $basketGroup = $('.basket-group[data-group="'+$dialog.data('basket-group')+'"]');
                        $basketGroup.find('.selected-profile').html(profile.CITY + '<br>' + address);
                        for(var k in CheckoutComponent.arResult.DELIVERY.PROFILES) {
                            if(k == data.id) {
                                CheckoutComponent.arResult.DELIVERY.PROFILES[k].SELECTED = 'Y';
                            } else {
                                CheckoutComponent.arResult.DELIVERY.PROFILES[k].SELECTED = 'N';
                            }
                        }
                    }
                    $('#new-delivery-profiles-dialog').modal('hide');
                    $profilesModal.modal();

                } else {
                    $errorMessage.empty();
                    $btn.prop('disabled', false);
                    $errorMessage.text('Ошибка сохранения профиля');
                }
            },
            'json'
        );
    }

    selectDeliveryProfile(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let $dialog = $('#delivery-profiles-dialog');
        let $currentProfile = $(e.target).closest('.delivery-profile-item');
        let profileId = $currentProfile.data('id');
        $dialog.find('.delivery-profile-item').removeClass('checked');
        $currentProfile.addClass('checked');
        for(var k in CheckoutComponent.arResult.DELIVERY.PROFILES) {
            if(k == profileId) {
                CheckoutComponent.arResult.DELIVERY.PROFILES[k].SELECTED = 'Y';
                let profile = CheckoutComponent.arResult.DELIVERY.PROFILES[k];
                let address = profile.STREET + ', ' + profile.HOUSE;
                if(profile.FLAT) {
                    address += ', ' + profile.FLAT;
                }
                let $basketGroup = $('.basket-group[data-group="'+$dialog.data('basket-group')+'"]');
                $basketGroup.find('.selected-profile').html(profile.CITY + '<br>' + address);
            } else {
                CheckoutComponent.arResult.DELIVERY.PROFILES[k].SELECTED = 'N';
            }
        }
    }

    static initDadata() {
        let self = this;
        $('.delivery-city-input').each(function(){
            self.initCityInput($(this));
        });
    }

    static initCityInput($cityInput: any) {
        let self = this;
        $cityInput.suggestions({
            url:'/?ajaxAction=searchCity',
            type: 'ADDRESS',
            count: 5,
            deferRequestBy: 1000,
            minChars: 3,
            onSelect: function(suggestion:any){
                $(this).parent('div').removeClass('error-input').addClass('success-input');
                let groupId = $(this).closest('.basket-group').data('group');
                let $saveBtn = $('.save-delivery-profile-btn');
                let $streetInput;
                if(typeof(groupId) != 'undefined') {
                    if (typeof (CheckoutComponent.arResult.BASKET.GROUPS[groupId].DADATA) == 'undefined') {
                        CheckoutComponent.arResult.BASKET.GROUPS[groupId].DADATA = {
                            city: {name:suggestion.value, fias:suggestion.data.fias_id},
                            address: suggestion.unrestricted_value,
                            fias: suggestion.data.fias_id,
                            zip: suggestion.data.postal_code,
                        };
                    }
                } else {
                    $(this).closest('.modal').find('input[name="fias"]').val(suggestion.data.fias_id);
                }
                $streetInput = $(this).closest('.basket-group, .modal').find('.delivery-street-input');
                $streetInput.val('').prop('disabled', false);
                $saveBtn.prop('disabled', true);
                self.initStreetInput($streetInput, groupId, suggestion.data.fias_id);
            },
            onSelectNothing: function() {
                $(this).parent('div').removeClass('success-input').addClass('error-input');
                $('.save-delivery-profile-btn').prop('disabled', true);
                $(this).closest('.basket-group, .modal')
                    .find('.delivery-house-input, .delivery-street-input').val('')
                    .prop('disabled', true)
                    .parent('div')
                    .removeClass('success-input')
                    .removeClass('error-input');
                let groupId = $(this).closest('.basket-group').data('group');
                if(typeof(groupId) != 'undefined') {
                    CheckoutComponent.arResult.BASKET.GROUPS[groupId].DADATA = {};
                }
            },
            onSuggestionsFetch: function() {
                grecaptcha.execute(window.recaptchaPublicKey, { action: 'contact' }).then(function (token) {
                    window.recaptchaToken = token;
                });
            },
            params: {
                from_bound: {value:'city'},
                to_bound: {value:'settlement'},
                recaptchaToken: window.recaptchaToken
            }
        });
    }
    
    static initStreetInput($streetInput: any, basketGroupId: number, fias: string) {
        let self = this;
        let $saveBtn = $('.save-delivery-profile-btn');
        let $houseInput;
        $streetInput.suggestions({
            url:'/?ajaxAction=searchCity',
            type: 'ADDRESS',
            count: 5,
            deferRequestBy: 1000,
            minChars: 3,
            onSelect: function(suggestion:any){
                $(this).parent('div').removeClass('error-input').addClass('success-input');
                if(typeof(basketGroupId) != 'undefined') {
                    if (CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA == '') {
                        CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA = {};
                    }
                    CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA.address = suggestion.unrestricted_value;
                    CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA.fias = suggestion.data.fias_id;
                    CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA.street = {name: suggestion.value, fias:suggestion.data.fias_id};
                } else {
                    $(this).closest('.modal').find('input[name="fias"]').val(suggestion.data.fias_id);
                }
                $houseInput = $(this).closest('.basket-group, .modal').find('.delivery-house-input');
                $houseInput.val('').prop('disabled', false);
                $saveBtn.prop('disabled', true);
                self.initHouseInput($houseInput, basketGroupId, suggestion.data.fias_id);
            },
            formatSelected: function(suggestion:any){
                if (suggestion.data.street_with_type) {
                    suggestion.value = suggestion.data.street_with_type;
                } else {
                    suggestion.value = suggestion.data.settlement_with_type;
                }
                
            },
            onSelectNothing: function() {
                $(this).parent('div').removeClass('success-input').addClass('error-input');
                $saveBtn.prop('disabled', true);
                $(this).closest('.basket-group, .modal')
                    .find('.delivery-house-input').val('')
                    .prop('disabled', true)
                    .parent('div')
                    .removeClass('success-input')
                    .removeClass('error-input');
                let groupId = $(this).closest('.basket-group').data('group');
                if(typeof(groupId) != 'undefined') {
                    CheckoutComponent.arResult.BASKET.GROUPS[groupId].DADATA.street = null;
                }
            },
            onSuggestionsFetch: function() {
                grecaptcha.execute(window.recaptchaPublicKey, { action: 'contact' }).then(function (token) {
                    window.recaptchaToken = token;
                });
            },
            params: {
                from_bound: {value:'area'},
                to_bound: {value:'street'},
                locations: [{fias_id: fias}],
                recaptchaToken: window.recaptchaToken
            }
        });
    }

    static initHouseInput($houseInput: any, basketGroupId: number, fias: string) {
        let self = this;
        let $saveBtn = $('.save-delivery-profile-btn');
        $houseInput.suggestions({
            url:'/?ajaxAction=searchCity',
            type: 'ADDRESS',
            count: 5,
            deferRequestBy: 1000,
            minChars: 1,
            onSelect: function(suggestion:any){
                $(this).parent('div').removeClass('error-input').addClass('success-input');
                if(typeof(basketGroupId) != 'undefined') {
                    CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA.address = suggestion.unrestricted_value;
                    CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA.fias = suggestion.data.fias_id;
                    CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA.zip = suggestion.data.postal_code;
                    CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA.house = {name: suggestion.value, fias:suggestion.data.fias_id};
                    CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DADATA.kladr = suggestion.data.kladr_id;

                    let serviceId = $('.basket-group[data-group="'+basketGroupId+'"]').find('.delivery-item.checked').data('id');
                    self.calculateDelivery([basketGroupId], [serviceId], true);
                } else {
                    $(this).closest('.modal').find('input[name="fias"]').val(suggestion.data.fias_id);
                    let houseAddr = suggestion.data.house_type + ' ' + suggestion.data.house;
                    if(suggestion.data.block) {
                        houseAddr += ', ' + suggestion.data.block_type+ ' ' + suggestion.data.block;
                    }
                    $(this).closest('.modal')
                        .find('input[name="house"]')
                        .val(houseAddr);
                    if(suggestion.data.flat) {
                        $(this).closest('.modal')
                            .find('input[name="flat"]')
                            .val(suggestion.data.flat_type + ' ' + suggestion.data.flat);
                    } else {
                        $(this).closest('.modal')
                            .find('input[name="flat"]')
                            .val('');
                    }
                }
                $saveBtn.prop('disabled', false);
            },
            formatSelected: function(suggestion:any){
                suggestion.value = suggestion.data.house_type + ' ' + suggestion.data.house;
                if(suggestion.data.block) {
                    suggestion.value += ', ' + suggestion.data.block_type+ ' ' + suggestion.data.block;
                }
                if(suggestion.data.flat) {
                    suggestion.value += ', ' + suggestion.data.flat_type+ ' ' + suggestion.data.flat;
                }
            },
            onSelectNothing: function() {
                $saveBtn.prop('disabled', true);
                $(this).parent('div')
                    .removeClass('success-input')
                    .addClass('error-input');
                let groupId = $(this).closest('.basket-group').data('group');
                if(typeof(groupId) != 'undefined') {
                    CheckoutComponent.arResult.BASKET.GROUPS[groupId].DADATA.house = null;
                }
            },
            onSuggestionsFetch: function() {
                grecaptcha.execute(window.recaptchaPublicKey, { action: 'contact' }).then(function (token) {
                    window.recaptchaToken = token;
                });
            },
            params: {
                from_bound: {value:'house'},
                to_bound: {value:'flat'},
                locations: [{fias_id: fias}],
                recaptchaToken: window.recaptchaToken
            }
        });
    }

    setDaData(e: JQuery.ChangeEvent<Document, undefined, any, any>) {
        let $basketGroup = $(e.target).closest('.basket-group');
        if(typeof(global.window.checkoutResult['DADATA']) == 'undefined') {
            return;
        }
        if($basketGroup.length) {
            let groupId = $basketGroup.data('group');
            CheckoutComponent.arResult.BASKET.GROUPS[groupId].DADATA = window.checkoutResult['DADATA'][groupId];
        } else {
            CheckoutComponent.arResult.DELIVERY.DADATA = window.checkoutResult['DADATA'][0];
        }
    }

    tryOpenBoxberryModal(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let self = this;
        let $deliveryItem = $(e.target).closest('.delivery-item');
        if($deliveryItem.hasClass('disabled')) {
            return;
        }
        $deliveryItem
            .addClass('disabled')
            .find('.bxblink')
            .html('<span class="delivery-price-loader"></span>');
        if(typeof(CheckoutComponent.arResult.BXB_PARAMS.API_KEY) == 'undefined') {
            $.ajax({
                url: '/',
                data: {ajaxAction: 'getBxbToken'},
                dataType: 'json',
                success: function(data){
                    if(typeof(data.token) != 'undefined') {
                        CheckoutComponent.arResult.BXB_PARAMS.API_KEY = data.token;
                        self.openBoxberryModal(e);
                    } else {
                        $(e.target)
                            .closest('.delivery-item_box__content')
                            .html('<p class="text-danger">В настоящее время служба доставки недоступна. Попробуйте позже.</p>');
                    }
                },
                error: function() {
                    $(e.target)
                        .closest('.delivery-item_box__content')
                        .html('<p class="text-danger">В настоящее время служба доставки недоступна. Попробуйте позже.</p>');
                }
            })
        } else {
            this.openBoxberryModal(e);
        }
    }
    openBoxberryModal(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let $basketGroup = $(e.target).closest('.basket-group');
        let groupId = $basketGroup.data('group');
        let weight = 0;
        let basketGroup = CheckoutComponent.arResult.BASKET.GROUPS[groupId];
        let basketItem;
        if(!weight) {
            for(var k in basketGroup['PRODUCTS']) {
                for(var productId in CheckoutComponent.arResult.BASKET.ITEMS) {
                    if(productId == basketGroup['PRODUCTS'][k]) {
                        for(var i in CheckoutComponent.arResult.BASKET.ITEMS[productId]['ITEMS']) {
                            basketItem = CheckoutComponent.arResult.BASKET.ITEMS[productId]['ITEMS'][i];
                            if(parseInt(basketItem.WEIGHT) > 0) {
                                weight += basketItem.WEIGHT * basketItem.QUANTITY;
                            } else {
                                weight += CheckoutComponent.arResult.BXB_PARAMS.DEFAULT_WEIGHT * basketItem.QUANTITY;
                            }
                        }
                    }
                }
            }
        }
        this.boxberry.open(
            function(data: any) {
                data.price = Math.round(parseInt(data.price));
                CheckoutComponent.arResult.BASKET.GROUPS[groupId].BOXBERRY = data;
                CheckoutComponent.arResult.BASKET.GROUPS[groupId].DELIVERY_PRICE = data.price;
                CheckoutComponent.arResult.BASKET.GROUPS[groupId].BXB_PVZ_PRICE = data.price;
                $('.bxblink')
                    .text('Boxberry: '+ data.address + " #" + data.id)
                    .closest('.delivery-item').removeClass('disabled');
                fetch(
                    `?ajaxAction=getDayDeclination&period=${parseInt(data.period) + 1}`
                ).then(async (response) => {
                    const objResponse = await response.json();

                    $basketGroup.find('.delivery-item.checked')
                        .find('.delivery-item-description.delivery-time')
                        .text('Ваш заказ будет доставлен ориентировочно через '+(parseInt(data.period)-1)+' - '+(parseInt(data.period)+1) + ' ' + objResponse.day_declination)
                    $basketGroup.find('div[data-code="bxb_pvz_delivery"]').find('.delivery-item-price').html(data.price + ' ₽');
                    CheckoutComponent.reloadComponents(['total']);
                });

            },
            CheckoutComponent.arResult.BXB_PARAMS.API_KEY,
            $.cookie('REGION_DADATA'),
            '',
            basketGroup.SUMM,
            weight,
            basketGroup.SUMM,
            '0',
            '0',
            '0'
        );
        return false;
    }
    setDeliveryDate(e: JQuery.ChangeEvent<Document, undefined, any, any>) {
        let $basketGroup = $(e.target).closest('.basket-group');
        let deliveryDate = $(e.target).closest('.delivery-item-params').find('input.delivery-date').val();
        CheckoutComponent.arResult.BASKET.GROUPS[$basketGroup.data('group')].DELIVERY_DATE = deliveryDate;
    }
    setDeliveryTime(e: JQuery.ChangeEvent<Document, undefined, any, any>) {
        let $basketGroup = $(e.target).closest('.basket-group');
        let deliveryTime = $(e.target).closest('.delivery-item-params').find('select.delivery-time').val();
        CheckoutComponent.arResult.BASKET.GROUPS[$basketGroup.data('group')].DELIVERY_TIME = deliveryTime;

    }
    setDeliveryService(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let $basketGroup = $(e.target).closest('.basket-group');
        let basketGroupId = $basketGroup.data('group');
        let $serviceContainer = $(e.target).closest('.delivery-item');
        let serviceId = $serviceContainer.data('id');
        let services = CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SERVICES;
        let Service;
        let $deliveryWrapper = $basketGroup.find('.cart-delivery-wrapper');
        CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SELECTED_DELIVERY = serviceId;
        if($serviceContainer.hasClass('checked')) {
            return;
        }
        for(var k in services) {
            if(services[k]['ID'] == serviceId) {
                Service = services[k];
                break;
            }
        }
        if(!Service) {
            return;
        }
        CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].DELIVERY_PRICE = Service['DELIVERY_PRICE'];
        $deliveryWrapper.find('.delivery-item')
            .removeClass('checked')
            .find('.delivery-item-params').hide();
        $serviceContainer.addClass('checked');

        // Установить активные платежные системы
        (<any>this).setActivePaySystems();

        CheckoutComponent.reloadComponents(['total'], true);
    }

    /**
     * Установить активные платежные системы
     */
    public setActivePaySystems()
    {
        let $basketGroup, $serviceContainer, $paySystemWrapper, $cashPaySystem, $deliveryDop, $balanceSwitcher;
        let services, Service, mapContainer, shopListContainer;

        for(var basketGroupId in CheckoutComponent.arResult.BASKET.GROUPS) {
            services = CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SERVICES;

            $basketGroup = $('.basket-group[data-group="'+ basketGroupId +'"]');
            $serviceContainer = $basketGroup.find('.delivery-item.checked');
            mapContainer  = $serviceContainer.data('map-id');
            shopListContainer = $serviceContainer.data('shop-list-id');
            $paySystemWrapper = $basketGroup.find('.checkout-paysystem');
            $cashPaySystem = $paySystemWrapper.find('.paysystem-item[data-code="cash"]');
            $deliveryDop = $serviceContainer.find('.delivery-item-params');
            $balanceSwitcher = $('#checkout-total').find('.checkout-balance-line')

            for(var k in services) {
                if(services[k]['CODE'] == $serviceContainer.data('code')) {
                    Service = services[k];
                    break;
                }
            }

            if($serviceContainer.length) {
                if (Service['CODE'] == 'pickup_today' || Service['CODE'] == 'pickup_tomorrow') {
                    this.CheckoutPickup = new CheckoutPickup(this.BX, this.ymaps, mapContainer, shopListContainer, basketGroupId);
                    this.CheckoutPickup.init();
                    if (Service['CODE'] == 'pickup_today') {
                        $paySystemWrapper.find('.paysystem-item[data-code="bank_card"]').hide();
                        $paySystemWrapper.find('.paysystem-item[data-code="sbp"]').hide();
                        $paySystemWrapper.find('.paysystem-item[data-code="cash"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="dolyame"]').hide();
                        if ($paySystemWrapper.find('.paysystem-item.checked').length == 0) {
                            this.setPaySystem('cash', $basketGroup);
                        }
                    }
                    if (Service['CODE'] == 'pickup_tomorrow') {
                        $paySystemWrapper.find('.paysystem-item[data-code="cash"]').hide();
                        $paySystemWrapper.find('.paysystem-item[data-code="bank_card"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="sbp"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="dolyame"]').show();
                        if ($paySystemWrapper.find('.paysystem-item.checked').length == 0) {
                            this.setPaySystem('bank_card', $basketGroup);
                        }
                    }
                } else {
                    if (Service['CODE'] == 'bxb_pvz_delivery') {
                        $paySystemWrapper.find('.paysystem-item[data-code="cash"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="bank_card"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="sbp"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="dolyame"]').show();
                        if ($paySystemWrapper.find('.paysystem-item.checked').length == 0) {
                            this.setPaySystem('bank_card', $basketGroup);
                        }
                    } else if (Service['CODE'] == 'POST' || Service['CODE'] == 'bxb_courier_delivery' || Service['CODE'] == 'mkad:default') {
                        $paySystemWrapper.find('.paysystem-item[data-code="cash"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="bank_card"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="sbp"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="dolyame"]').show();
                        if ($paySystemWrapper.find('.paysystem-item.checked').length == 0) {
                            this.setPaySystem('bank_card', $basketGroup);
                        }
                    } else if (Service['CODE'] == '5lb_express') {
                        $paySystemWrapper.find('.paysystem-item[data-code="cash"]').hide();
                        $paySystemWrapper.find('.paysystem-item[data-code="bank_card"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="sbp"]').hide();
                        $paySystemWrapper.find('.paysystem-item[data-code="dolyame"]').hide();
                        if ($paySystemWrapper.find('.paysystem-item.checked').length == 0) {
                            this.setPaySystem('bank_card', $basketGroup);
                        }
                    } else if (Service['CODE'] == '5_post') {
                        $paySystemWrapper.find('.paysystem-item[data-code="cash"]').hide();
                        $paySystemWrapper.find('.paysystem-item[data-code="bank_card"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="sbp"]').hide();
                        $paySystemWrapper.find('.paysystem-item[data-code="dolyame"]').hide();
                        if ($paySystemWrapper.find('.paysystem-item.checked').length == 0) {
                            this.setPaySystem('bank_card', $basketGroup);
                        }
                    } else {
                        $paySystemWrapper.find('.paysystem-item[data-code="bank_card"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="sbp"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="cash"]').show();
                        $paySystemWrapper.find('.paysystem-item[data-code="dolyame"]').show();
                    }
                }
                if (Service['CODE'] == 'mkad:default') {
                    $cashPaySystem.find('.paysystem-title').text($cashPaySystem.data("alternate-text"));
                } else {
                    $cashPaySystem.find('.paysystem-title').text($cashPaySystem.data("default-text"));
                }
                if (!$deliveryDop.is(':visible')) {
                    $deliveryDop.slideToggle();
                }
                if (Service['CODE'] == 'pickup_today') {
                    CheckoutComponent.arResult.USE_USER_BALANCE = "N";
                    $balanceSwitcher.find('input[type="checkbox"]').prop('checked', false);
                    $balanceSwitcher.hide();
                } else {
                    $balanceSwitcher.show();
                }
            }
        }
    }

    setPaySystem(code: string, $basketGroup: any)
    {
        let $paySystem = $basketGroup.find('.checkout-paysystem').find('.paysystem-item[data-code="'+code+'"]');
        CheckoutComponent.arResult.BASKET.GROUPS[$basketGroup.data('group')]['SELECTED_PAY_SYSTEM'] = {
            ID: $paySystem.data('id'),
            CODE: $paySystem.data('code'),
        };
        $basketGroup.find('.paysystem-item').removeClass('checked');
        $paySystem.addClass('checked');
    }
    showCalendar(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let self = this;
        this.BX.calendar({
            node: e.target,
            field: e.target,
            bTime: false,
        });
        let mindate = $(e.target).data('min-date') ? $(e.target).data('min-date') : false
        CheckoutComponent.changeCalendar(mindate);
    }
    static checkPaySystem() {
        let $basketGroup;

        for(var basketGroupId in CheckoutComponent.arResult.BASKET.GROUPS) {
            $basketGroup = $('.basket-group[data-group="'+ basketGroupId +'"]');
            let $activePaySystem = $basketGroup.find('.checkout-paysystem').find('.paysystem-item.checked');

            if ($activePaySystem.length == 0 || $activePaySystem.is(":hidden")) {
                $activePaySystem.removeClass('checked');
                CheckoutComponent.arResult.BASKET.GROUPS[$basketGroup.data('group')]['SELECTED_PAY_SYSTEM'] = null;
            } else {
                if ($activePaySystem.length > 0) {
                    CheckoutComponent.arResult.BASKET.GROUPS[$basketGroup.data('group')]['SELECTED_PAY_SYSTEM'] = {
                        ID: $activePaySystem.data('id'),
                        CODE: $activePaySystem.data('code'),
                    };
                }
            }
        }
    }
    open5postModal(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let $basketGroup = $(e.target).closest('.basket-group');
        let groupId = $basketGroup.data('group');

        this.delivery5postMap.onSelectPoint = (point: any) => {
            const pointInfoContainer = $basketGroup.find('.five_postlink');
            if (point) {
                $.post(
                    '/?ajaxAction=getTariff',
                    {
                        point: point,
                        group: CheckoutComponent.arResult.BASKET.GROUPS[groupId],
                        items: CheckoutComponent.arResult.BASKET.ITEMS,
                    },
                    function(data) {
                        var tariff = 250;

                        if (data.success) {
                            tariff = data.tariff;
                            CheckoutComponent.arResult.BASKET.GROUPS[groupId].DELIVERY_PRICE = tariff;
                            CheckoutComponent.arResult.BASKET.GROUPS[groupId].FIVE_POST_PRICE = tariff;
                        } else {
                            CheckoutComponent.arResult.BASKET.GROUPS[groupId].DELIVERY_PRICE = tariff;
                            CheckoutComponent.arResult.BASKET.GROUPS[groupId].FIVE_POST_PRICE = tariff;
                        }

                        CheckoutComponent.arResult.BASKET.GROUPS[groupId].FIVE_POST_DATA = point;
                        CheckoutComponent.reloadComponents(['total']);
                        $basketGroup.find('.5post-wrapper').find('.delivery-item-price').html(tariff + ' ₽');
                    },
                    'json'
                );

                pointInfoContainer.html( `
                    <h3>${point.label}</h3>
                    <p><b>Адрес:</b> ${point.resultAddress}</p>
                    ${point.additional ? `<p><b>Местонахождение:</b> ${point.additional}</p>` : ''}
                    <p><b>Телефон:&nbsp</b>${point.phone}</p>
                    <p><b>Время работы:</b></p>
                    <ul>${point.workHoursBrief}</ul>
                `);
            } else {
                pointInfoContainer.html('Выбрать пункт выдачи на карте...');
            }
            $('#delivery-5post').modal('hide');
        }
        $('#delivery-5post').modal('show');
        
        return false;
    }
}